import { ViewTabs } from "@/components/layout/view-tabs";

/** Runs | Builds — the two views of the Walkthroughs page. */
export function WalkthroughsTabs({
  projectId,
  current,
}: {
  projectId: string;
  current: "runs" | "builds";
}) {
  return (
    <ViewTabs
      label="Walkthrough views"
      current={current}
      tabs={[
        {
          id: "runs",
          label: "Runs",
          to: `/projects/${projectId}/walkthroughs`,
        },
        {
          id: "builds",
          label: "Builds",
          to: `/projects/${projectId}/walkthroughs/builds`,
        },
      ]}
    />
  );
}
